import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';

const categories = ['All', 'Weddings', 'Corporate', 'Social Events', 'Decor'];
const galleryItems = [
  { id: 1, image: 'https://source.unsplash.com/random/800x600/?wedding,ceremony', category: 'Weddings', title: 'Beachfront Wedding Ceremony' },
  { id: 2, image: 'https://source.unsplash.com/random/800x600/?corporate,meeting', category: 'Corporate', title: 'Annual Shareholders Meeting' },
  { id: 3, image: 'https://source.unsplash.com/random/800x600/?birthday,party', category: 'Social Events', title: '30th Birthday Celebration' },
  { id: 4, image: 'https://source.unsplash.com/random/800x600/?wedding,reception', category: 'Weddings', title: 'Garden Reception' },
  { id: 5, image: 'https://source.unsplash.com/random/800x600/?event,decor', category: 'Decor', title: 'Custom Floral Arrangements' },
  { id: 6, image: 'https://source.unsplash.com/random/800x600/?corporate,event', category: 'Corporate', title: 'Product Launch Event' },
  { id: 7, image: 'https://source.unsplash.com/random/800x600/?table,setting', category: 'Decor', title: 'Elegant Table Settings' },
  { id: 8, image: 'https://source.unsplash.com/random/800x600/?graduation,party', category: 'Social Events', title: 'Graduation Celebration' },
  { id: 9, image: 'https://source.unsplash.com/random/800x600/?wedding,cake', category: 'Weddings', title: 'Custom Wedding Cake' },
  { id: 10, image: 'https://source.unsplash.com/random/800x600/?conference,venue', category: 'Corporate', title: 'Tech Conference Setup' },
  { id: 11, image: 'https://source.unsplash.com/random/800x600/?lighting,decor', category: 'Decor', title: 'Ambient Lighting Design' },
  { id: 12, image: 'https://source.unsplash.com/random/800x600/?anniversary,party', category: 'Social Events', title: '25th Anniversary Celebration' }
];

export default function Gallery() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [openImage, setOpenImage] = useState(null);

  const filteredImages = selectedTab === 0 ? galleryItems : galleryItems.filter(item => item.category === categories[selectedTab]);

  return (
    <div className="w-full px-2 sm:px-4 md:px-12 xl:px-32 py-8">
      <section className="mb-12 text-center">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 text-primary">Event Gallery</h1>
        <p className="text-lg md:text-xl mb-8">Browse through our portfolio of previous events to get inspired for your own celebration.</p>
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map((category, idx) => (
            <button
              key={category}
              className={`px-4 py-2 rounded font-semibold border ${selectedTab === idx ? 'bg-primary text-white border-primary' : 'bg-white text-primary border-primary/30'} transition`}
              onClick={() => setSelectedTab(idx)}
            >
              {category}
            </button>
          ))}
        </div>
      </section>
      <section className="mb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {filteredImages.map(item => (
            <div key={item.id} className="relative cursor-pointer group" onClick={() => setOpenImage(item)}>
              <img src={item.image} alt={item.title} className="w-full h-64 object-cover rounded-xl shadow" />
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white p-4 rounded-b-xl opacity-0 group-hover:opacity-100 transition">
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="text-sm">{item.category}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* Full Size Image Dialog */}
      <Dialog open={!!openImage} onClose={() => setOpenImage(null)} className="fixed z-50 inset-0 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black/80" />
          {openImage && (
            <div className="relative bg-black rounded-xl p-4 max-w-3xl w-full">
              <button className="absolute top-2 right-2 text-white text-2xl" onClick={() => setOpenImage(null)}>&times;</button>
              <img src={openImage.image} alt={openImage.title} className="w-full h-auto max-h-[80vh] object-contain rounded" />
              <div className="p-2 text-white">
                <h3 className="text-lg font-semibold">{openImage.title}</h3>
                <p className="text-sm">{openImage.category}</p>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}
